<template>

    <div v-if='editable' class='striped_row d-flex flex-column'>
        <template v-for='(item, index) in value'>
            <inline-error :key='"error" + index' v-bind:errors='errors' :type='"codes." + index + ".*"'></inline-error>
            <p class='striper d-flex flex-row align-items-center' :key='index'>
                <coding :key='"" + index + ":" + resetCounter' :editable='editable' :value='item' />
                <button class="btn btn-round btn-sm btn-danger" v-on:click='removeItem(index)'>{{ $t('translations.remove')}}</button>
            </p>
        </template>
        <button v-on:click='value.push({id: null})' class="btn btn-primary btn-round btn-sm mt-1">{{ $t('translations.add_code')}}</button>
    </div>
    <table v-else class='w-100 table table-striped table-compact'>
        <thead>
            <tr>
                <th>{{ $t('translations.code_header')}}</th>
                <!-- <th>{{ $t('translations.code_scheme')}}</th> -->
                <th>{{ $t('translations.code_code')}}</th>
                <th>{{ $t('translations.code_description_id')}}</th>
                <th>{{ $t('translations.code_term')}}</th>
                <th>{{ $t('translations.code_value')}}</th>
                <th>{{ $t('translations.code_units')}}</th>
                <th>{{ $t('translations.code_descriptive_text')}}</th>
            </tr>
        </thead>
        <tbody>
            <template v-if='value && value.length'>
                <tr :key='index' v-for='(item, index) in value'>
                    <td v-text='item.header'></td>
                    <!-- <td v-text='item.scheme'></td> -->
                    <td v-text='item.code'></td>
                    <td v-text='item.description_id'></td>
                    <td v-text='item.term'></td>
                    <td v-text='item.value'></td>
                    <td v-text='item.units'></td>
                    <td v-text='item.descriptive_text'></td>
                </tr>
            </template>
            <template v-else>
                <tr>
                    <td colspan='7' class='text-center'>{{$t('translations.no_codes')}}</td>
                </tr>
            </template>
        </tbody>
    </table>
</template>

<script>
export default {
    props: {
        value: {
        },
        editable: {
            default: true,
        },
        errors: {
            default: function() {return []}
        }
    },
    data() {
        return {
            new_code: {},
            resetCounter: 0,
        };
    },
    computed: {
        
    },
    watch: {
        
    },
    mounted() {
        
    },
    methods: {
        removeItem(index) {
            //console.log(this.value, index);
            // We have to force the items to re-render, otherwise the autocomplete sub-component
            // gets re-used and shows the value of the old item at that index position.
            this.resetCounter++;
            this.value.splice(index, 1);
        }
    },
};
</script>

<style scoped>
    .btn-clear {
        width: 22px; 
        height: 22px; 
        font-size: 13px; 
        padding: 0px;
        border: 1px solid #a0a0a0;
        border-radius: 0.25rem;
        font-weight: bold;
        color: rgb(120, 130, 140);
    }
</style>